export default __webpack_public_path__ + "src/appV2/redesign/CbhWrapped/assets/coin-wrapped.png";